import { localePath, DEFAULT_LANGUAGES } from '@/utils/i18nRoutes';
import { RegionPlugin } from '@/plugins/region';

export const useIsLoggedInRedirect = (mutation, router) => {
  if (mutation?.type === 'auth/setIsLoggedIn') {
    const currentRoute = router.history.current.name?.split('___')?.[0];

    if (mutation?.payload && currentRoute === 'login') {
      const nextPath = localePath({
        name: 'dashboard',
        language: router.app.$i18n.locale,
        defaultLanguage: DEFAULT_LANGUAGES[RegionPlugin.getRegion()]
      });
      router.replace(nextPath);
    }
  }
};
